export default "__VITE_ASSET__BTwmrKs3__"